import React from "react"
import { CustomBox } from "../../../spacings"
import MenuListItem, { MenuListItemInput } from "./MenuListItem"

export interface MenuListItem {}

export interface MenuListProps {
  items: MenuListItemInput[]
  bordersBottom?: boolean
  px?: number
  center?: boolean
}

const MenuList = ({ items, bordersBottom, center, px }: MenuListProps) => {
  return (
    <div>
      {items.map((item, index) => (
        <CustomBox px={px} key={index}>
          <MenuListItem
            item={item}
            bottomBorder={bordersBottom}
            center={center}
            px={px}
          />
        </CustomBox>
      ))}
    </div>
  )
}

export default MenuList
